/**
 * Empty state component when no tasks match the filter.
 */

interface EmptyStateProps {
  filter: string;
}

export function EmptyState({ filter }: EmptyStateProps) {
  const messages: Record<string, { title: string; description: string }> = {
    Active: {
      title: 'No active tasks',
      description: 'Tasks assigned to you will appear here when ready to work.',
    },
    All: {
      title: 'No tasks assigned',
      description: 'You don\'t have any tasks assigned yet.',
    },
    Pending: {
      title: 'No pending tasks',
      description: 'All your tasks are either active or complete.',
    },
    Done: {
      title: 'No completed tasks',
      description: 'Tasks you complete will appear here.',
    },
  };

  const content = messages[filter] ?? messages['All'];

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      {/* Empty inbox icon */}
      <div className="w-16 h-16 mb-6 rounded-2xl bg-surface-highlight flex items-center justify-center">
        <svg
          className="w-8 h-8 text-ink-subtle"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 13h4l2 3h6l2-3h4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 13V8a2 2 0 012-2h14a2 2 0 012 2v5M3 13v5a2 2 0 002 2h14a2 2 0 002-2v-5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h3 className="text-lg font-semibold text-ink mb-1">{content?.title}</h3>
      <p className="text-sm text-ink-muted max-w-xs">{content?.description}</p>
    </div>
  );
}
